module.exports = __webpack_public_path__ + "fonts/FreightNeoProMedium-Italic.81afa239.otf";